<div class="app__internal--links app__role--players--card" id="add-api-key-managed-container">
  @if (isDataLoading) {
    <div class="ph-item w-full loader-body-item m-0 p-0 border-0">
      <div class="ph-col-12 p-0 pt-6">
        <div class="ph-row">
          <div class="ph-col-4 h-[10px]"></div>
          <div class="ph-col-6 empty"></div>
          <div class="ph-col-2 h-[10px]"></div>
        </div>
      </div>
    </div>
  }


  @if (!isDataLoading) {
    <mat-dialog-content class="mat-dialog-content">
      <mat-accordion class="prevent-click" [@.disabled]="true">
        <mat-expansion-panel hideToggle [expanded]="true" 
          class="parametersPanel shadow-none rounded-t-none rounded-b-none mt-[-10px] px-1" 
          [ngClass]="apiMotorValueList?.length == 0 ? 'setEmptyPanelDefault' : ''">
          <mat-expansion-panel-header class="h-8 disable_ripple">
            <mat-panel-title>
              <div class="header-section">
                <p (click)="$event.stopPropagation()">
                  Zillow (Residential Property Data)
                </p>
                @if (mode != 'view' && allowEditPermission) {
                  <button
                    class="app__internal--links--add--btn app__centered-item w-fit leading-[34px]"
                    (click)="$event.stopPropagation();addEditMotorData();">
                      <span style="color: #25508e; font-size: 16px;position: relative;" class="material-icons">settings</span>
                      <span class="relative"> Manage </span>
                  </button>
                }
              </div>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div style="margin: 0px -24px;" class="mt-4">
            @if (apiMotorValueList.length == 0) {
              <div class="flex justify-center border rounded-lg border-[#D3DCE8] p-5" >
                <img style="margin: 0px 16px;position: relative;top: -5px;" src="assets/images/zillow-big-logo.svg" />
                <p class="m-0 font-semibold text-xs text-[#18191C]">No <span
                class="text-[#25508e]">live data feeds</span> to show</p>
              </div>
            }
            <div class="folder-view__association-files max-w-full w-full">
              <div class="association-files-table flex fl-col width-100per">
                <div class="width-100per" style="overflow-x: hidden;">
                  @for (subLink of apiMotorValueList; track subLink; let i = $index) {
                    <div class="association-files-table__body width-100per" style="background: #ffffff"
                      >
                      <div style="display: flex; justify-content: space-between">
                        <div class="body-card flex"
                          style="padding: 16!important; width: 100%; border-radius: 8px; justify-content: space-between; align-items: center;">
                          <div class="test-zeropostion">
                            <div style="display: flex" class="mrr-10px">
                              <img src="assets/images/zero-zilliow.svg" alt="" />
                              <p class="name-title text-truncate "
                                style="font-weight: normal !important;line-height: 32px;margin-left: 6px;">
                                {{subLink.payload?.address | truncateStrPipe : 22}}
                              </p>
                            </div>
                          </div>
                          <button (click)="$event.stopPropagation();addEditMotorData();"
                            class="more-vote-btn cursor-pointer flex-center"
                        style="  
                            background: #E2F9E4;
                            border-radius: 4px;
                            height: 24px;
                            width: 24px;
                        " mat-icon-button>
                            <span class="material-icons" style="color: #59AB62;">link</span>
                          </button>
                        </div>
                      </div>
                    </div>
                  }
                </div>
              </div>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </mat-dialog-content>
  }
</div>